module.exports = __webpack_public_path__ + "static/media/ck_logo_login.89238060.png";